export default __webpack_public_path__ + "static/media/tennis-ball-icon.f84c5387.svg";